module.exports = __webpack_public_path__ + "static/img/green-1.b939473.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/Cattle/green-1.png
// module id = J2jJ
// module chunks = 0